export const NOTEBOOK_BREAKPOINT = 1400;
